<template>
  <el-table-column
    prop="leader_user.last_name"
    label="Területi vezető"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span v-if="scope.row.leader_user">{{ scope.row.leader_user.last_name +' '+ scope.row.leader_user.first_name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'leader_user.last_name',
  };
</script>
